






























import { Component, Provide, Prop, Vue } from 'vue-property-decorator';
import LayerOne from './components/LayerOne.vue';
import LayerTwo from './components/LayerTwo.vue';
import LayerThree from './components/LayerThree.vue';

@Component({
  components: {
    LayerOne,
    LayerTwo,
    LayerThree,
  },
})

export default class App extends Vue {


  // cmpApi = null;
  // tcModel = null;
  // storeTCString = null;
  // initialLayer = null;


  visible = false;
  view = "close";
  forcedFixedPosition = false;

  mounted() {
    console.log( "App: mounted()" );

    // @ts-ignore
    this.view = this.$root.initialLayer;
    // @ts-ignore
    this.visible = this.$root.initialLayer == "close"  ? false: true;
    
    let bodyTag = document.getElementsByTagName("body")[0];

    if ( this.visible)
     setTimeout( () => { window.scrollTo(0, 0); }, 250 );
      // bodyTag.style.cssText = "height: 100%; overflow: hidden";
  }

  // beforeDestroy() {
  //   console.log( "App: beforeDestroy()" );
  // }

  handleChangeView( viewDestination : string ) : void {
    console.log( "App: handleChangeView() = > " + viewDestination );
    let bodyTag = document.getElementsByTagName("body")[0];

    if (viewDestination == "close" ) {
			// bodyTag.style.overflow =  "initial";
			// bodyTag.style.height =  "initial";

      this.visible = false;
    }
    else {

			// bodyTag.style.overflow =  "hidden";
      // bodyTag.style.height =  "100%";
      window.scrollTo(0, 0);
     setTimeout( () => { window.scrollTo(0, 0); }, 250 );

    // @ts-ignore
      let setHeight = () => { document.getElementById("__cmp_body").style.maxHeight = ( viewDestination == "layerOne" ) ? "960px" : "98vh"; };


      if (this.visible)
        setHeight ();
      else {
        this.visible = true;
        this.$nextTick ( setHeight );
      }
      this.view = viewDestination;
  }

}

}
